import {Component, inject, Signal, ViewChild} from '@angular/core';
import {Store} from '@ngrx/store';
import {IStore} from '../../../../shared/shared-models/store/store';
import {selectSelectedStore} from '../../../user-access/user-stores-store/user-store.selectors';
import {ILabelDesign, ITestLabelData} from '../../../../shared/shared-components/components/shared-label-designer/models/label-interfaces';
import {LabelPrinterComponent} from '../../../../shared/shared-components/components/shared-label-designer/components/label-printer/label-printer.component';

@Component({
  selector: 'app-feature-label-maker',
  templateUrl: './feature-label-maker.component.html',
  styleUrls: ['./feature-label-maker.component.scss'],
  standalone: false,
})
export class FeatureLabelMakerComponent {

  @ViewChild(LabelPrinterComponent) printerComponent!: LabelPrinterComponent;

  private readonly _store = inject(Store);

  protected readonly selectedStore: Signal<IStore> = this._store.selectSignal(selectSelectedStore);

  labelDesign: ILabelDesign;
  labelData: ITestLabelData[] = [];

  onPrintRequest(event: { design: ILabelDesign, data: ITestLabelData[] }): void {
    this.labelDesign = event.design;
    this.labelData = event.data;
    setTimeout(() => {
      if (this.printerComponent) {
        void this.printerComponent.printLabels();
      }
    });
  }
}
